import {inject, Injectable} from '@angular/core';
import {NGXLogger} from 'ngx-logger';
import {from} from 'rxjs';
import {PortalMessageBroker} from '../portal/portal-message-broker';


export interface ExampleDataV1 {
  readonly exampleId: string;
}


@Injectable({
  providedIn: 'root'
})
export class IntentActionService {

  private _logger = inject(NGXLogger);
  private _portalMessageBroker = inject(PortalMessageBroker);

  private readonly _exampleV1 = 'de.just-farming:example:example';

  constructor() {
    if (this.isRunningInPortal()) {
      this._portalMessageBroker.registerIntentCallback(this._exampleV1, '1', (data => {
        this.handleExampleV1(data);
      }));

      this._portalMessageBroker.allIntentCallbackRegistered();
    }
  }

  /**
   * Prüft, ob die App im Portal läuft
   */
  public isRunningInPortal(): boolean {
    return this._portalMessageBroker.isRunningInPortal();
  }

  public doExampleV1(
    data: ExampleDataV1,
  ): void {
    this.doEmit(this._exampleV1, '1', data);
  }

  handleExampleV1(
    data: ExampleDataV1
  ): void {
    this.doEmit(this._exampleV1, '1', data);
  }

  private doEmit(
    intentId: string,
    intentVersion: string,
    data: any,
  ): void {
    if (!this.isRunningInPortal()) {
      throw new Error('app is not running in portal');
    }

    const promise = this._portalMessageBroker.emitIntent(intentId, intentVersion, data);
    from(promise)
      .subscribe(
        value => {
          this._logger.debug('IntentActionService.doEmit(): id=' + intentId + ' version=' + intentVersion + ' handles successful', value);
        },
        error => {
          this._logger.debug('IntentActionService.doEmit(): id=' + intentId + ' version=' + intentVersion + ' dispatch failed', error);
        },
      );
  }
}
